import React from 'react';
import { NotificationThread } from './types';

/**
 * Utility function to clean and format channel string
 */
export const cleanChannelString = (channels: string): string => {
    const channelsArray = channels.split(',');
    const cleanedArray = channelsArray.filter(item => item.trim().length > 0);
    return cleanedArray.join(',');
};

/**
 * Utility function to parse channels from notification thread
 */
export const parseNotificationChannels = (notificationThread: NotificationThread): {
    channelsString: string;
    channelsArray: string[];
} => {
    let selectedChannelsArray = notificationThread.channels.split(',');
    selectedChannelsArray = selectedChannelsArray.filter(item => item.trim().length > 0);
    const selectedChannels = selectedChannelsArray.join(',');
    
    return {
        channelsString: selectedChannels,
        channelsArray: selectedChannelsArray
    };
};

/**
 * Utility function to strip HTML tags from string
 */
export const stripHtmlTags = (html: string | undefined): string => {
    if (!html) return '';
    return html.replace(/<[^>]+>/g, '');
};
